"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatoLottoEnumToJSON = exports.StatoLottoEnumFromJSONTyped = exports.StatoLottoEnumFromJSON = exports.StatoLottoEnum = void 0;
/**
 *
 *
 * 1 = Inserita
 *
 * 2 = InEsecuzione
 *
 * 3 = InErrore
 *
 * 4 = Completata
 *
 * 5 = Scaduta
 * @export
 * @enum {string}
 */
var StatoLottoEnum;
(function (StatoLottoEnum) {
    StatoLottoEnum[StatoLottoEnum["NUMBER_1"] = 1] = "NUMBER_1";
    StatoLottoEnum[StatoLottoEnum["NUMBER_2"] = 2] = "NUMBER_2";
    StatoLottoEnum[StatoLottoEnum["NUMBER_3"] = 3] = "NUMBER_3";
    StatoLottoEnum[StatoLottoEnum["NUMBER_4"] = 4] = "NUMBER_4";
    StatoLottoEnum[StatoLottoEnum["NUMBER_5"] = 5] = "NUMBER_5";
})(StatoLottoEnum = exports.StatoLottoEnum || (exports.StatoLottoEnum = {}));
function StatoLottoEnumFromJSON(json) {
    return StatoLottoEnumFromJSONTyped(json, false);
}
exports.StatoLottoEnumFromJSON = StatoLottoEnumFromJSON;
function StatoLottoEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.StatoLottoEnumFromJSONTyped = StatoLottoEnumFromJSONTyped;
function StatoLottoEnumToJSON(value) {
    return value;
}
exports.StatoLottoEnumToJSON = StatoLottoEnumToJSON;
